import { useCallback } from 'react';

import { useSignupWithOtpMutation } from '@ocx/graphql';

type SignupWithOTPParams = {
  otp: string;
  session: string;
};

type SignupWithOTPResult = {
  tokens: { accessToken: string; refreshToken: string } | null;
};

export const useSignupWithOTP = () => {
  const [_signupWithOtp, { loading }] = useSignupWithOtpMutation({ fetchPolicy: 'network-only' });

  const signupWithOTP = useCallback(
    async (params: SignupWithOTPParams): Promise<SignupWithOTPResult> => {
      const res = await _signupWithOtp({
        variables: {
          input: {
            otp: params.otp,
            session: params.session,
          },
        },
      });

      if (!res.data) {
        return { tokens: null };
      }

      if (
        res.data.exchangeSessionAndOTPToAuthToken.__typename ===
        'ExchangeSessionAndOTPToAuthTokenResultFailedIncorrectOTP'
      ) {
        return { tokens: null };
      }

      return {
        tokens: res.data.exchangeSessionAndOTPToAuthToken.tokens,
      };
    },
    [_signupWithOtp],
  );

  return { signupWithOTP, isLoading: loading };
};
